/* import __COLOCATED_TEMPLATE__ from './superscript.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();